<template>
  <div class="flex flex-column" style="height: 100%; background-color: #0350D6;">
    <RouterView></RouterView>
  </div>
</template>

<script setup>
</script>
